import RoleFilter from './RoleFilter.component';

export default RoleFilter;
